
import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutModule } from './features/layout/layout-module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CookieConsentComponent } from './features/cookie-consent/cookie-consent';
import { ToasterComponent } from "./features/layout/toaster-component/toaster-component";
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LayoutModule,
    MatSelectModule,
    MatFormFieldModule,
    CookieConsentComponent,
    ToasterComponent
],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.scss'
})
export class App {

}

